import { AuthFeedbackPage } from '@shared/components/error-pages/auth-feedback-page/AuthFeedbackPage';
import * as React from 'react';

import type { SessionExpiredErrorProps } from './SessionExpiredError.types';

/**
 * Session expired page — landing-page-style dark layout.
 *
 * Renders OUTSIDE the app layout (no header/nav). Uses a full-page dark theme
 * with the same swirl pattern as the landing page. The "Go to login" action is
 * provided by the page so this component stays free of auth/router dependencies.
 *
 * Separated from ErrorPage because:
 * - Different visual style (dark landing-page layout vs. white error layout)
 * - Custom primary action ("Go to login" instead of logout/help)
 * - No auth dependency (session is already expired)
 */
const SessionExpiredError = React.memo(
  ({ onLogin }: Readonly<SessionExpiredErrorProps>): React.ReactElement => {
    return (
      <AuthFeedbackPage
        type="session-expired"
        primaryActionLabel="Go to login"
        onPrimaryAction={onLogin}
      />
    );
  }
);

SessionExpiredError.displayName = 'SessionExpiredError';

export { SessionExpiredError };
